<div class="login-page">

  <div class="login-card">

    <div class="header-container">
      <img src="../../../../assets/images/logo.png" alt="logo">
      <h3 class="title">Accesso</h3>
    </div>

    <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
      <p class="alert-title"><b>Errore!</b></p>
      <ul class="alert-message-list">
        <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
      </ul>
    </nb-alert>

    <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
      <p class="alert-title"><b>Successo!</b></p>
      <ul class="alert-message-list">
        <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
      </ul>
    </nb-alert>

    <form (ngSubmit)="login()" #form="ngForm" aria-labelledby="title">

      <div class="form-control-group">
        <label class="label" for="input-username">Username</label>
        <input nbInput
               fullWidth
               [(ngModel)]="user.username"
               #username="ngModel"
               name="username"
               id="input-username"
               placeholder="Enter username"
               autofocus
               [status]="username.dirty ? (username.invalid ? 'danger' : 'success') : 'basic'"
               required>
        <ng-container *ngIf="username.invalid && username.touched">
          <p class="caption status-danger">Inserisci un username valido!</p>
        </ng-container>
      </div>

      <div class="form-control-group">
        <label class="label" for="input-password">Password</label>
        <nb-form-field>
          <input nbInput
                 fullWidth
                 [(ngModel)]="user.password"
                 #password="ngModel"
                 [type]="showPassword ? 'text' : 'password'"
                 name="password"
                 id="input-password"
                 placeholder="Enter password"
                 [status]="password.dirty ? (password.invalid ? 'danger' : 'success') : 'basic'"
                 required minlength="6" maxlength="30">
          <button type="button" nbSuffix nbButton ghost (click)="showPassword = !showPassword"
                  [attr.aria-label]="showPassword ? 'Nascondi password' : 'Mostra password'">
            <nb-icon [icon]="showPassword ? 'eye-outline' : 'eye-off-2-outline'" pack="eva"></nb-icon>
          </button>
        </nb-form-field>
        <ng-container *ngIf="password.invalid && password.touched">
          <p class="caption status-danger">Inserisci una password (6–30 caratteri)!</p>
        </ng-container>
      </div>

      <button nbButton fullWidth [disabled]="submitted || !form.valid" class="login-btn">
        Accedi
      </button>

    </form>

    <section class="another-action">
      Hai dimenticato la password?
      <a class="text-link" [routerLink]="['/auth/reset-password']">Reimpostala</a>
    </section>

  </div>

</div>
